/* eslint-disable linebreak-style */
/* eslint-disable indent */
/* eslint-disable eqeqeq */
/* eslint-disable import/no-cycle */
import axios from 'axios';
import i18n from '../../i18n';
import store from '../../redux/store';
import userConstants from '../../services/Login/ActionType';
import { NOT_FOUND_ERRORS } from './constants';
import { CREATE_NEW_USER } from '../../constants/common.const';

export default function errorHandler(error) {
    const config = error?.config || error?.response?.config;
    if (axios.isCancel(error)) {
        return Promise.reject(error);
    }
    if (error?.message === 'Network Error') {
        return Promise.reject(error?.message);
    }
    if (config?.skipGlobalErrorHandler) {
        return Promise.reject(error);
    }

    const status = error?.response?.status;
    // Normalize response data to a comparable string
    const rawData = error?.response?.data;
    const dataString = typeof rawData === 'string'
        ? rawData
        : (rawData?.messages?.[0]?.message
            || rawData?.messages?.[0]?.['debug-message']
            || rawData?.message
            || '');
    const normalized404Text = String(dataString).toLowerCase().trim();
    const isItemNotFound404 = status == 404 && NOT_FOUND_ERRORS.some(msg => normalized404Text?.includes(msg));
    const isCreateNewUserFunction = status == 400 && (config?.functionName) === CREATE_NEW_USER;
    if ((status == 403
        && error?.response?.data == i18n.t('Access to the specified resource is forbidden.')) || (status == 409 && !(
            error?.response?.data?.messages?.[0]?.id == 'address.suggestion' ||
            error?.response?.data?.messages?.[0]?.id == 'address.invalid' ||
            error?.response?.data?.messages?.[0]?.id == 'placeOrder.checkout.popup.body.message.ground' ||
            error?.response?.data?.messages?.[0]?.id == 'placeOrder.checkout.popup.body.message.air' ||
            error?.response?.data?.messages?.[0]?.id == 'placeorder.shipping.restrictions'
        )) || status == 401 || status == 500 || status === undefined || (status == 400 && !isCreateNewUserFunction) || (status == 404 && !isItemNotFound404) || status == 422
    ) {
        status == 401 ? store.dispatch({ type: userConstants.LOGIN_FAILURE_401, payload: true }) :
            status == 500 || status == 409 || status == 400 || status == 404 || status == 422 ? store.dispatch({ type: userConstants.API_FAILS, payload: error?.response?.data }) : error?.response === undefined && status === undefined ? store.dispatch({ type: userConstants.API_FAILS, payload: 'Request Canceled.' }) :
                '';
    }
}
